import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { SENTIMENT_COLOR_SET } from '../../../../config/ColorSet';

class SentimentBar extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount(){
    const data = this.props.data;
    let chart = null;
    if(this.props.type == 'quick'){
      this.createQuickSentimentBar(chart, data);
    }
    else {
    }
  }

  componentWillUnmount(){
    if(this.chart) this.chart.dispose();
  }

  createQuickSentimentBar = (chart, dataSet) => {

    chart = am4core.create(this.sentimentBarChart, am4charts.XYChart);
    chart.data = dataSet.sentiment;

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    dateAxis.renderer.minGridDistance = 20;
    dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
    dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
    dateAxis.renderer.labels.template.rotation = 90;  
    dateAxis.renderer.labels.template.horizontalCenter = "left";
    dateAxis.renderer.labels.template.verticalCenter = "middle";
    
    dateAxis.dataFields.date = "date";
    dateAxis.renderer.grid.template.location = 0;

    // Create series
    let positiveSeries = chart.series.push(new am4charts.ColumnSeries());
    positiveSeries.dataFields.valueY = "positive";
    positiveSeries.dataFields.dateX = "date";
    positiveSeries.name = `${dataSet.keyword} (긍정)`;
    positiveSeries.stacked = true;
    positiveSeries.columns.template.fill = am4core.color(SENTIMENT_COLOR_SET.positive);
    positiveSeries.columns.template.stroke = am4core.color(SENTIMENT_COLOR_SET.positive)
    // positiveSeries.tooltipText = `${dataSet.keyword} (긍정) : [bold]{valueY}[/]`
    positiveSeries.columns.template.tooltipText = `${dataSet.keyword} (긍정) : [bold]{valueY}[/]`;

    let negativeSeries = chart.series.push(new am4charts.ColumnSeries());
    negativeSeries.dataFields.valueY = "negative";
    negativeSeries.dataFields.dateX = "date";
    negativeSeries.name = `${dataSet.keyword} (부정)`;
    negativeSeries.stacked = true;
    negativeSeries.columns.template.fill = am4core.color(SENTIMENT_COLOR_SET.negative);
    negativeSeries.columns.template.stroke = am4core.color(SENTIMENT_COLOR_SET.negative)
    // negativeSeries.tooltipText = `${dataSet.keyword} (부정) : [bold]{valueY}[/]`
    negativeSeries.columns.template.tooltipText = `${dataSet.keyword} (부정) : [bold]{valueY}[/]`;

    let mixSeries = chart.series.push(new am4charts.ColumnSeries());
    mixSeries.dataFields.valueY = "mix";
    mixSeries.dataFields.dateX = "date";
    mixSeries.name = `${dataSet.keyword} (혼합)`;
    mixSeries.stacked = true;
    mixSeries.columns.template.fill = am4core.color(SENTIMENT_COLOR_SET.mix);
    mixSeries.columns.template.stroke = am4core.color(SENTIMENT_COLOR_SET.mix)
    // mixSeries.tooltipText = `${dataSet.keyword} (혼합) : [bold]{valueY}[/]`
    mixSeries.columns.template.tooltipText = `${dataSet.keyword} (혼합) : [bold]{valueY}[/]`;

    // let neutralSeries = chart.series.push(new am4charts.ColumnSeries());
    // neutralSeries.dataFields.valueY = "neutral";
    // neutralSeries.dataFields.dateX = "date";
    // neutralSeries.name = `${dataSet.keyword} (중립)`;
    // neutralSeries.stacked = true;
    // neutralSeries.columns.template.fill = am4core.color(SENTIMENT_COLOR_SET.neutral);
    // neutralSeries.columns.template.stroke = am4core.color(SENTIMENT_COLOR_SET.neutral)
    // // neutralSeries.tooltipText = `${dataSet.keyword} (중립) : [bold]{valueY}[/]`
    // neutralSeries.columns.template.tooltipText = `${dataSet.keyword} (중립) : [bold]{valueY}[/]`;

    chart.legend = new am4charts.Legend();
    // chart.cursor = new am4charts.XYCursor();

    this.chart = chart;
  }

  render(){
    return(
      <div id="sentiment-bar" ref={ref=>(this.sentimentBarChart=ref)} style={{width: this.props.width, height: this.props.height}}></div>
    )
  }
}

export default SentimentBar;
